import dynamic from 'next/dynamic';
import { FC } from 'react';
import { ParagraphPassMapFragment } from '../../../generated/types';
import Container from '../../Layout/Container';

interface PassMapProps {
  data: ParagraphPassMapFragment;
}

const Map = dynamic(() => import('./Map'), {
  ssr: false,
});

const PassMap: FC<PassMapProps> = ({ data }) => {
  return (
    <Container>
      <Map data={data.data.items} />
    </Container>
  );
};

export default PassMap;
